import { render, staticRenderFns } from "./CardChickInventory.vue?vue&type=template&id=737f52b8&scoped=true"
import script from "./CardChickInventory.vue?vue&type=script&lang=js"
export * from "./CardChickInventory.vue?vue&type=script&lang=js"
import style0 from "./CardChickInventory.vue?vue&type=style&index=0&id=737f52b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737f52b8",
  null
  
)

export default component.exports